// export const baseURL = "http://localhost:4444/web/api/"; // URL for local
// export const baseURL = "https://apiloyaltystaging.novusloyalty.com/web/api/"; // URL for staging
export const baseURL = "https://apiloyalty.novusloyalty.com/web/api/"; // URL for Live
export const cardUrl = 'https://buy.stripe.com/8wM4gC7oh0bJ7qodQR'

